module.exports = __webpack_public_path__ + "img/xuxiangnan.a3f49b99.jpg";